import { render } from "./CoursewarePreview.vue?vue&type=template&id=5cc0d50c&scoped=true"
import script from "./CoursewarePreview.vue?vue&type=script&lang=js"
export * from "./CoursewarePreview.vue?vue&type=script&lang=js"

import "./CoursewarePreview.vue?vue&type=style&index=0&id=5cc0d50c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cc0d50c"

export default script